import { apiClient } from '../utils/apiClient';

export interface AvailabilityParams {
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
}

export interface DeskAvailability {
  id: string;
  // Add other properties as needed based on API response
}

export class AvailabilityService {
  static async getDesksAvailability(params: AvailabilityParams): Promise<DeskAvailability[]> {
    const { start_date, end_date, start_time, end_time } = params;
    
    const endpoint = `/api/availability/desks?start_date=${start_date}&end_date=${end_date}&start_time=${start_time}&end_time=${end_time}`;
    
    console.log('📡 AvailabilityService.getDesksAvailability() - API Request:', {
      endpoint,
      fullUrl: `${process.env.REACT_APP_API_URL}${endpoint}`,
      params: { start_date, end_date, start_time, end_time }
    });
    
    const response = await apiClient.get(endpoint);

    console.log('📥 AvailabilityService.getDesksAvailability() - API Response:', {
      status: response?.success ? 'success' : 'error',
      dataLength: response?.data?.length || 0,
      data: response?.data
    });

    return response?.data || [];
  }
}